import React from "react";

export default function BusinessPlan() {
  return (
    <div className="page">
      <h1>Investor-Ready Business Plan</h1>
      <p>Business plan placeholder.</p>
    </div>
  );
}
